import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TimesGridActions from './actions/TimesGridActions';
import TimesGridStateStore from './stores/TimesGridStateStore';
import DesktopTimesGridContent from './views/DesktopTimesGridContent';
import MobileTimesGridContent from './views/MobileTimesGridContent';

export default class Content extends Component {
    static propTypes = {
        // Required Parameters
        gridActions: PropTypes.instanceOf(TimesGridActions).isRequired,
        gridStateStore: PropTypes.instanceOf(TimesGridStateStore).isRequired,

        // Optional Parameters
        guid: PropTypes.string, // for users to be able to identify view,
        isMobile: PropTypes.bool,
        numRowsOnLoad: PropTypes.number, // > 0
        shouldShowAllRows: PropTypes.bool,
    };

    static defaultProps = {
        guid: null,
        numRowsOnLoad: 5,
        shouldShowAllRows: false,
    };

    render() {
        if (this.props.isMobile) {
            return (
                <MobileTimesGridContent {...this.props} />
            );
        }

        return (
            <DesktopTimesGridContent {...this.props} />
        );
    }
}
